import React from "react";
import { ImgList } from "../components/ImgList/ImgList";
import styles from "./SeasonalTravelDestinationPlan.module.scss";
export function PlanDaily(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.planDailyBox
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.title
  }, props.title), /*#__PURE__*/React.createElement("div", {
    className: styles.description
  }, props.description), /*#__PURE__*/React.createElement(ImgList, {
    list: props.imgs
  }));
}